import { Skeleton } from '@/components/ui/skeleton'

const SupportContentSkeleton = () => {
  return (
    <div className='flex flex-col gap-4'>
      <Skeleton className='h-7 w-1/2 border-0 opacity-40' />
      <Skeleton className='h-4 w-full border-0 opacity-40' />
      <Skeleton className='h-4 w-11/12 border-0 opacity-40' />
      <Skeleton className='h-4 w-10/12 border-0 opacity-40' />
      <Skeleton className='h-4 w-5/6 border-0 opacity-40' />
      <Skeleton className='h-4 w-3/4 border-0 opacity-40' />
    </div>
  )
}

export default SupportContentSkeleton
